import React, { useState, useEffect } from 'react';
import { CommonModalProps } from './Types';
import { Modal, InputSelect } from '@wajeez-web/components/ui';
import { ProductGroupType } from '@wajeez-web/core/types';

interface ProductGroupModalProps
  extends CommonModalProps<{
    promoCodeId: number;
    productGroupId: number;
  }> {
  productGroups: ProductGroupType[];
}

const ProductGroupModal: React.FC<ProductGroupModalProps> = ({
  isOpen,
  onClose,
  data,
  productGroups,
  onSubmit,
}) => {
  const [productGroup, setProductGroup] = useState<{
    promoCodeId: number;
    productGroupId: number;
  }>({ promoCodeId: 0, productGroupId: 0 });

  const productGroupSelectOptions = () => {
    return productGroups.map((item) => {
      return {
        label: item.groupName,
        value: item.id,
      };
    });
  };

  useEffect(() => {
    data
      ? setProductGroup({ ...data })
      : setProductGroup({ promoCodeId: 0, productGroupId: 0 });
  }, [data]);

  return (
    <Modal
      title={'Product Group'}
      open={isOpen}
      onClose={onClose}
      withScroll={false}
      onSubmit={() => {
        onSubmit && onSubmit(productGroup);
      }}
    >
      <div className="space-y-3">
        <InputSelect
          label="Product Group"
          name="productGroupId"
          value={productGroupSelectOptions().find(
            (item) => item.value === productGroup.productGroupId
          )}
          onChange={(name, val: any) => {
            setProductGroup({ ...productGroup, productGroupId: val?.value });
          }}
          options={productGroupSelectOptions()}
        />
      </div>
    </Modal>
  );
};

export default ProductGroupModal;
